import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import { config } from './config';

Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.sentry.environment,
  // TODO - activate this once live to test how nicely Sentry and track
  //   performance
  // integrations: [new BrowserTracing()],
  // tracesSampleRate: 1.0,
  tracesSampleRate: 0.0,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </RecoilRoot>
  </React.StrictMode>,
);
